import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	settings: {
		id: 'navigation-kit-project-settings-button.settings',
		defaultMessage: 'Project settings',
		description: 'Project settings navigation button on project header.',
	},
});
